import type { IOption } from '@cian/ui-kit/types/option';

import { REALTOR_RATING_DEFAULT_PERIOD_VALUE, REALTOR_RATING_MIN_PERIOD } from '../../../constants';

/**
 * Формирует опции селектора для филда Период
 */
export const getRealtorRatingPeriodFieldOptions = (currentYear: number) => {
  const periods: IOption[] = [{ value: REALTOR_RATING_DEFAULT_PERIOD_VALUE, label: 'За всё время' }];

  for (let year = currentYear; year >= REALTOR_RATING_MIN_PERIOD; year--) {
    periods.push({ value: year.toString(), label: year.toString() });
  }

  return periods;
};
